// Couche de données (Google Tag Manager / Consent Mode v2).
// Sécurisé : ne casse jamais le site si GTM n'est pas encore chargé.
export const track = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

// Numéro au format international pour WhatsApp (sans + ni espaces).
export const WHATSAPP_NUMBER = '33676583038';
export const WHATSAPP_MESSAGE =
  'Bonjour Frelon33™, je souhaite obtenir des informations concernant une intervention.';
export const whatsappUrl = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Mise à jour Consent Mode v2 (appelée depuis la bannière cookies).
export const updateConsent = (granted) => {
  if (typeof window === 'undefined') return;
  const value = granted ? 'granted' : 'denied';
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value,
      analytics_storage: value,
    });
  }
  track(granted ? 'cookie_consent_accepted' : 'cookie_consent_denied');
};
